import Index from '@/pages/Index';
import SearchPage from '@/pages/search';
import SciexPage from '@/pages/sciex';
import Deal from '@/pages/deal/index';
import Cookie from '@/pages/deal/cookie';
import Privacy from '@/pages/deal/privacy';
export default [
  { path: '/', element: <Index /> },
  { path: '/searchPage', element: <SearchPage /> },
  { path: '/sciexPage', element: <SciexPage /> },
  { path: '/UseTerm', element: <Deal /> },
  { path: '/cookie', element: <Cookie /> },
  { path: '/Privacy', element: <Privacy /> }
];
